import { PlusOneOutlined, Title } from '@mui/icons-material';
import Select from "react-select";
import { Header } from 'antd/lib/layout/layout';
import React, { useEffect, useState } from 'react'
import { getActiveItemRecords, getOrgKeyValue, getPriceList } from '../../../services';
import toast from 'react-hot-toast';
import { Divider, Radio, Tag } from 'antd'; // Import Tag component
import Loader from '../../Common/Loader';
import { Button } from 'react-bootstrap';
import { itemMultiPriceListReport } from '../../../services/Inventory/PriceListService';

const ItemsListPriceList = () => {
    const [orgOptions, setOrgOptions] = useState([]);
    const [org, setOrg] = useState({});
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [selectedPriceList, setSelectedPriceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredPriceList, setFilteredPriceList] = useState([])
    const [operation, setOperation] = useState("ADD")
    const tempRow = {
        item: "",
        customPrice: 0,
        units: [],
    };
    const [rows, setRows] = useState([tempRow]);
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");

    useEffect(() => {
        getOrgKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setOrg(options[0]);
                setOrgOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    useEffect(() => {
        if (org.value) {
            getPriceRecords();
        }
    }, [org]);

    const getPriceRecords = () => {
        setLoading(true);
        var request = {
            page: 0,
            search: '',
            size: -1,
            uuid: org.value,
        };
        getPriceList(request).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket.data;
                d.reverse();
                let options = d.map((e) => {
                    return { label: e.title, value: e.recordId };
                });
                setPriceListOptions(options);
            } else {
                setLoading(false);
                toast(res.message);
            }
        }).catch((error) => {
            console.error(error);
            setLoading(false);
        });
    };

    useEffect(() => {
        var request = {
            page: 0,
            search: "",
            size: -1,
        };
        getActiveItemRecords(request).then((res) => {
            if (res.errorCode === 0) {
                let dd = res?.responsePacket?.data;
                const options = res?.responsePacket?.data.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                    sPrice: d?.sellingPriceValue,
                    pPrice: d?.purchasePriceValue,
                    units: [
                        { value: d.itemUnitId, label: d.itemUnitTitle },
                        { value: d.weightUnitId, label: d.weightUnitTitle },
                    ],
                }));
                setItemOptions(options);
                setItemOptions2(options);

            } else {
                toast(res.message);
            }
        });
    }, [setItemOptions, setItemOptions2, , setRows]);

    const handleUnit = (e, i) => {
        const obj = [...rows];
        obj[i].unitId = e.value;
        obj[i].unitTitle = e.label;
        obj[i].unit1 = { value: e.value, label: e.label };
        setRows(obj);
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item = e;
        obj[i].units = e.units;
        obj[i].unit1 = e.units[0];
        obj[i].unitId = e.units[0].value;
        obj[i].unitTitle = e.units[0].label;
        setRows(obj);
        handleFilterItems();
    };

    const handleFilterItems = () => {
        var send = false;
        var filterOptions = [];
        itemOptions2 && itemOptions2.map((a) => {
            rows && rows.map((b) => {
                if (a.value === b?.item?.value) {
                    send = true;
                }
            });
            if (!send) {
                filterOptions.push(a);
            }
            send = false;
        });
        setItemOptions(filterOptions);
    };
    useEffect(() => {
        if (priceListOptions.length > 0) {
            const priceList = priceListOptions.filter((a) => !selectedPriceList.find((e) => e.value == a.value))
            setFilteredPriceList(priceList)
        }
    }, [selectedPriceList, priceListOptions])

    const handleOrgSelect = (e) => {
        if (selectedPriceList.find((p) => p.value == e.value)) {
            // let data = selectedPriceList.filter((price) => price.value !== e.value);
            // setSelectedPriceList(data);
        } else {
            let data = [...selectedPriceList, e];
            setSelectedPriceList(data);
        }
    };

    const handleTagRemove = (value) => {
        setSelectedPriceList(selectedPriceList.filter((tag) => tag.value !== value));
    };

    const handleAddRow = () => {
        setRows([...rows, tempRow]);
        handleFilterItems();
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
    };
    const handleCustom = (e, i) => {
        const obj = [...rows];
        obj[i].customPrice = Number(e.target.value);
        setRows(obj);
    };
    const changeOperation = (e) => {
        setOperation(e.target.value)
    }

    const handleSave = () => {

        if (rows.length === 0) {
            toast("Please select items");
            return;
        }

        let data = rows.some((e) => !(e.item?.value))

        if (data) {
            toast("Please select items");
            return;
        }
        if (!operation) {
            toast("Please select operation");
            return;
        }
        let payload = {
            multiplePriceList: selectedPriceList.map((e) => { return { title: e.label, uuid: e.value } }),
            multipleItemList: rows.map((e) => {
                return {
                    unitId: e?.unitId,
                    unitTitle: e?.unitTitle,
                    itemId: e?.item?.value,
                    itemTitle: e?.item?.label,
                    customPrice: e?.customPrice,
                    recordId: e?.e?.item?.value,
                    price: 0,
                    priceListId: ""
                }
            }),
            type: operation

        }




        itemMultiPriceListReport(payload).then((e) => {
            toast(e?.message)
        })
            .catch((err) => {
                toast(err)
            })

    };


    return (
        <div style={{ marginLeft: "20px", marginTop: "20px", height: "90vh" }}>
            <Header style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}>
                Items Price List
            </Header>
            <div style={{ display: "flex", height: "auto" }}>
                <div style={{ width: "40%", marginRight: "20px", marginTop: "17px" }}>
                    <Select
                        className="text-left"
                        options={filteredPriceList}
                        onChange={handleOrgSelect}
                        placeholder="Select a Price List"
                    />
                </div>
                <div style={{ width: "60%" }}>
                    {selectedPriceList?.length > 0 && (
                        <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap" }}>
                            {selectedPriceList.map((e) => (
                                <Tag
                                    key={e.value}
                                    closable
                                    onClose={() => handleTagRemove(e.value)}
                                    style={{
                                        margin: "5px",
                                        border: "1px solid #1890ff",
                                        backgroundColor: "#e6f7ff",
                                        color: "#1890ff",
                                        borderRadius: "512px",
                                        fontSize: "14px",
                                        padding: "5px"
                                    }}
                                >
                                    {e.label}
                                </Tag>
                            ))}
                        </div>
                    )}
                    {selectedPriceList.length > 0 && <Button style={{ margin: "20px", float: "right" }} onClick={() => setSelectedPriceList([])} type='danger'>Clear All</Button>}
                </div>
            </div>
            {selectedPriceList?.length > 0 && <div style={{ height: "50%", marginTop: "40px", borderTop: "1px solid" }}>
                <div>
                    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Radio.Group
                            defaultValue="add"
                            buttonStyle="solid"
                            style={{
                                display: "flex",
                                gap: "20px",
                            }}
                            onChange={changeOperation}
                            value={operation}
                        >
                            <Radio.Button
                                value="ADD"
                                style={{
                                    padding: "10px 20px",
                                    backgroundColor: "#f1f1f1",
                                    color: "#007bff",
                                    border: "none",
                                    borderRadius: "0",
                                    fontWeight: "bold",
                                }}
                                className="tab-btn"
                            >
                                ADD & UPDATE
                            </Radio.Button>
                            <Radio.Button
                                value="DELETE"
                                style={{
                                    padding: "10px 20px",
                                    backgroundColor: "#f1f1f1",
                                    color: "#007bff",
                                    border: "none",
                                    borderRadius: "0",
                                    fontWeight: "bold",
                                }}
                                className="tab-btn"
                            >
                                DELETE
                            </Radio.Button>
                        </Radio.Group>

                    </div>

                    <table className="customTable">
                        <tbody>
                            <tr>
                                <td>Sno.</td>
                                <td>Item</td>
                                <td>custom Price</td>
                                <td>Unit</td>
                                <td></td>
                            </tr>
                            {rows &&
                                rows.map((a, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td style={{ width: "300px" }}>
                                                <Select
                                                    options={itemOptions}
                                                    value={a.item}
                                                    onChange={(e) => handleItem(e, i)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    min={0}
                                                    value={a.customPrice}
                                                    onChange={(e) => handleCustom(e, i)}
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    options={a.units}
                                                    value={a.unit1}
                                                    onChange={(e) => handleUnit(e, i)}
                                                />
                                            </td>
                                            <td
                                                style={{ cursor: "pointer" }}
                                                onClick={() => handleClear(a.item.value, i)}
                                            >
                                                {rows.length > 1 && <i className="fa fa-times"></i>}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>

                    <button
                        id="ember1426"
                        className="btn btn-default addbtn mt-3"
                        onClick={handleAddRow}
                    >
                        <PlusOneOutlined style={{ color: "blue" }} /> New Row
                    </button>
                    <Button
                        onClick={() => setRows([tempRow])}
                        type='danger'
                        style={{ margin: "20px", float: "right" }}
                    >Clear All
                    </Button>
                </div>
                <Button style={{ margin: "20px" }} onClick={handleSave} type='submit'>Submit</Button>
            </div>}
        </div>
    );
};

export default ItemsListPriceList;
